import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { useLocation } from 'react-router'
import {
  getCountry,
  getLanguage,
  getText,
} from '../../internal/TextLabels/text'
import { moduleFetch } from '../../util/module-fetch'
import config from '../../../../config'
import { modules } from '../../../modules'
import { useModuleInfo } from '../../../modules/provider/ModuleInfoProvider'
import { notify } from '../../store/actions/notification-actions'
import ModuleLoadError from '../../../modules/components/ModuleLoadError/ModuleLoadError'
import ModuleVersionNotification from '../../../modules/components/ModuleVersionNotification'

const PaymentManagementModule = ({
  doFetch,
  getState,
  pathname,
  authorities,
  role,
  queryParamsHandler,
}) => {
  const [showVersionNotification, setShowVersionNotification] = useState(false)
  const { moduleInfo, setModuleInfo } = useModuleInfo()
  const [error, setError] = useState(false)
  const [updateInProgress, setUpdateInProgress] = useState(false)
  const [forceReload, setForceReload] = useState(false)
  const location = useLocation()

  // eslint-disable-next-line no-unused-vars
  const versionCallback = info => {
    const json = JSON.parse(info)
    if (moduleInfo && json._timestamp) {
      if (moduleInfo !== json._timestamp) {
        setShowVersionNotification(true)
      }
    } else {
      setModuleInfo(json._timestamp || '')
    }
  }

  useEffect(() => {
    modules.paymentManagementApp
      .app()
      .then(module => {
        module.inject(modules.paymentManagementApp.name, doFetch, {
          authorities,
          role,
          countryCode: getCountry(),
          language: getLanguage(),
          basePath: modules.paymentManagementApp.basePath,
          getState,
          notify,
          queryParamsHandler,
        })
      })
      .catch(reason => {
        if (reason.name === 'ChunkLoadError') {
          setUpdateInProgress(true)
        } else if (reason.message.includes('module.inject is not a function')) {
          /* Try once to reload the page to either fix the error or to get ChunkLoadError */
          setForceReload(true)
        } else {
          setError(true)
        }
      })
  }, [pathname, location])

  return (
    <div id={modules.paymentManagementApp.name}>
      {error || updateInProgress || forceReload ? (
        <ModuleLoadError
          name={`${modules.paymentManagementApp.name}.transactions`}
          updateInProgress={updateInProgress}
          forceReload={forceReload}
        />
      ) : (
        getText('general.loading')
      )}

      {showVersionNotification && (
        <ModuleVersionNotification
          moduleName={getText(`modules.${modules.paymentManagementApp.name}`)}
          hide={() => setShowVersionNotification(false)}
        />
      )}
    </div>
  )
}

const mapStateToProps = state => ({
  authorities: state.auth.authorities,
  getState: () => state,
  pathname: state.router.location.pathname,
  role: state.auth.role,
})

const mapDispatchToProps = dispatch => ({
  doFetch: (url, options) => {
    return dispatch(
      moduleFetch(config.federatedModules.paymentManagement, url, options),
    )
  },
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(PaymentManagementModule))
